import apiService from '../Api'
import { IContestEvaluator, IEvaluatorsSyncPayload } from './interfaces'

export default class ContestEvaluatorsService {
  async list(contestId: number | string): Promise<{ total: number; data: IContestEvaluator[] }> {
    return apiService.get(`/contests/${contestId}/evaluators`).then((response) => response.data)
  }

  async sync(
    contestId: number | string,
    payload: IEvaluatorsSyncPayload
  ): Promise<{ total: number; data: IContestEvaluator[] }> {
    return apiService.put(`/contests/${contestId}/evaluators`, payload).then((response) => response.data)
  }
}
